/*
 * @Author: JamesWong
 * @Description: 激活码模块中文包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:35:13
 */
export default {
  activated: '已激活',
  unactivated: '未激活',
  order: '序号',
  activeCode: '激活码',
  machineNumber: '机器编码',
  machineCode: '设备机器码',
  activeTime: '激活时间',
  operation: '操作',
  delete: '删除',
  dataNotAvailable: '暂无数据',
  cancelActived: '取消激活',
  cancel: '取消',
  comfirm: '确定',
  subactiveCodeCanceled: '取消激活',
  subactiveCodeCanceledTips: '确定取消该设备的激活码？',
  subactiveCodeDeleted: '删除子激活码',
  subactiveCodeDeletedTips: '确定删除该条激活码吗？'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/activeCode.js